<template>
    <div class="awardsList">
        <div class="awardsList__type">
            <ul class="awardsList__type__container">
                <li v-for="(type, index) in awardsType" :key="`type${index}`"
                    :class="{ 'active': awardsTypeChoice === type }" @click="clickTypeTag($event, type)">
                    {{ type }}
                </li>
            </ul>
            <div class="tab__line" :style="{ width: `calc(${tabLineWidth}px - 0.25em)`, left: `${tabLinePosition}px` }">
            </div>
        </div>
        <div class="awardsList__container">
            <swiper :modules="swiperOption.awardsListModules" slidesPerView="auto" :slidesPerGroup="2"
                :spaceBetween="16" :breakpoints="{
                    767: {
                        slidesPerView: 5,
                        slidesPerGroup: 5,
                        spaceBetween: 12
                    }
                }" :grid="{
                    rows: 2,
                    fill: 'row'
                }" :pagination="{
                    clickable: true,
                    dynamicBullets: true,
                    dynamicMainBullets: 4

                }" :navigation="{
                    nextEl: '.nextBtn',
                    prevEl: '.preBtn'
                }">
                <swiper-slide v-for="awards in awardsList" :key="`${awards.member_uniqid}-${awards.type}`"
                    class="awardsList__container__box">
                    <a :href="awards.blog_link" target="_blank">
                        <div class="awardsList__container__img">
                            <img :src="awards.avatar" class="rwdimg" :alt="awards.display_name" loading="lazy" />
                        </div>
                        <div class="awardsList__container__content">
                            <p>{{ awards.display_name }}</p>
                            <p class="awardName">{{ awards.type }}</p>
                        </div>
                    </a>
                </swiper-slide>
            </swiper>
            <div class="nextBtn for-pc"></div>
            <div class="preBtn for-pc"></div>
        </div>
    </div>
</template>

<script setup>
import { computed, reactive, ref, watchEffect } from 'vue';

import { Swiper, SwiperSlide } from 'swiper/vue';
import { Grid, Pagination, Navigation } from 'swiper';

import "swiper/css";
import "swiper/css/grid";
import "swiper/css/pagination";
import 'swiper/css/navigation';

/** 類別金奬 */
import goldenList from './../../public/gold.json';

const LINE_PADDING = 21;

// const props = defineProps({
//     type: String, // Gold | Silver
// });

const swiperOption = reactive({
    navigation: computed(() => screen.width > 767),
    awardsListModules: computed(() => screen.width > 767 ? [Grid, Pagination, Navigation] : [Grid])
})
let awardsTypeChoice = ref('美食|食譜');
const tabLineWidth = ref(126);
const tabLinePosition = ref(0);

const awardsTypeCategory = goldenList.channels.map(channel => channel.name);
let awardsType = computed(() => awardsTypeCategory); // 金銀獎的頻道會不同嗎？


const clickTypeTag = (event, type) => {
    awardsTypeChoice.value = type;
    tabLineWidth.value = event.target.clientWidth - LINE_PADDING * 2;
    tabLinePosition.value = event.target.offsetLeft;
}

watchEffect(() => {
    awardsTypeChoice.value = '美食|食譜';
    tabLineWidth.value = screen.width > 767 ? 126 : 82;
    tabLinePosition.value = 0;
});

const awardsList = computed(() => {
    return goldenList.channels
        .filter(channel => channel.name === awardsTypeChoice.value)[0].winners;
    // if (!props.type) return [];
    // const pattern = new RegExp(`.*${props.type === 'Gold' ? '金獎' : '銀獎'}`);
    // return goldenList.channels
    //     .filter(channel => channel.name === awardsTypeChoice.value)[0].winners
    //     .filter(winner => winner.type.match(pattern));
});


</script>

<style lang="scss" scoped>
@import '@/styles/awardsList';
</style>
